import { customFetch } from "../customFetch";

export const auth = {
  getMe: () => customFetch("/api/auth/me"),
};
